export default __webpack_public_path__ + "static/media/loader1.95569ca8.gif";